// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * InvoiceGroupLinkAttributes type.
 * @typedef {object} InvoiceGroupLinkAttributes
 * @property {string} id - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {string | null} invoiceGroupId - Attribute value.
 * @property {string | null} invoiceId - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 */
/**
 * Attributes accepted by InvoiceGroupLinkCreateAttributes.
 * @typedef {object} InvoiceGroupLinkCreateAttributes
 * @property {InvoiceGroupLinkAttributes["invoiceGroupId"] | null} [invoiceGroupId] - Permitted invoiceGroupId value.
 * @property {InvoiceGroupLinkAttributes["invoiceId"] | null} [invoiceId] - Permitted invoiceId value.
 */
/**
 * Attributes accepted by InvoiceGroupLinkUpdateAttributes.
 * @typedef {object} InvoiceGroupLinkUpdateAttributes
 * @property {InvoiceGroupLinkAttributes["invoiceGroupId"] | null} [invoiceGroupId] - Permitted invoiceGroupId value.
 * @property {InvoiceGroupLinkAttributes["invoiceId"] | null} [invoiceId] - Permitted invoiceId value.
 */
/**
 * Frontend model for InvoiceGroupLink.
 * @augments {FrontendModelBase<InvoiceGroupLinkAttributes, InvoiceGroupLinkCreateAttributes, InvoiceGroupLinkUpdateAttributes, InvoiceGroupLinkAttributes["id"], string>}
 */
class InvoiceGroupLink extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "InvoiceGroupLink",
      attributes: [
        "id",
        "createdAt",
        "invoiceGroupId",
        "invoiceId",
        "updatedAt",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      invoice: {type: "belongsTo"},
      invoiceGroup: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      invoice: "Invoice",
      invoiceGroup: "InvoiceGroup",
    }
  }

  /** @returns {InvoiceGroupLinkAttributes["id"]} - Attribute value. */
  id() { return /** @type {InvoiceGroupLinkAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {InvoiceGroupLinkAttributes["id"] | null} newValue - New attribute value.
   * @returns {InvoiceGroupLinkAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {InvoiceGroupLinkAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {InvoiceGroupLinkAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {InvoiceGroupLinkAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {InvoiceGroupLinkAttributes["invoiceGroupId"]} - Attribute value. */
  invoiceGroupId() { return /** @type {InvoiceGroupLinkAttributes["invoiceGroupId"]} */ (this.readAttribute("invoiceGroupId")) }

  /**
   * @param {InvoiceGroupLinkAttributes["invoiceGroupId"] | null} newValue - New attribute value.
   * @returns {InvoiceGroupLinkAttributes["invoiceGroupId"] | null} - Assigned value.
   */
  setInvoiceGroupId(newValue) { return /** @type {InvoiceGroupLinkAttributes["invoiceGroupId"] | null} */ (this.setAttribute("invoiceGroupId", newValue)) }

  /** @returns {InvoiceGroupLinkAttributes["invoiceId"]} - Attribute value. */
  invoiceId() { return /** @type {InvoiceGroupLinkAttributes["invoiceId"]} */ (this.readAttribute("invoiceId")) }

  /**
   * @param {InvoiceGroupLinkAttributes["invoiceId"] | null} newValue - New attribute value.
   * @returns {InvoiceGroupLinkAttributes["invoiceId"] | null} - Assigned value.
   */
  setInvoiceId(newValue) { return /** @type {InvoiceGroupLinkAttributes["invoiceId"] | null} */ (this.setAttribute("invoiceId", newValue)) }

  /** @returns {InvoiceGroupLinkAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {InvoiceGroupLinkAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /**
   * Returns invoice relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<InvoiceGroupLink, import("./invoice.js").Invoice, import("./invoice.js").InvoiceCreateAttributes>} - Relationship helper.
   */
  invoiceRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<InvoiceGroupLink, import("./invoice.js").Invoice, import("./invoice.js").InvoiceCreateAttributes>} */ (this.getRelationshipByName("invoice")) }

  /**
   * Returns invoice.
   * @returns {import("./invoice.js").Invoice | null} - Loaded related model.
   */
  invoice() { return this.invoiceRelationship().loaded() }

  /**
   * Builds invoice.
   * @param {import("./invoice.js").InvoiceCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./invoice.js").Invoice} - Built related model.
   */
  buildInvoice(attributes = {}) { return this.invoiceRelationship().build(attributes) }

  /**
   * Loads invoice.
   * @returns {Promise<import("./invoice.js").Invoice | null>} - Loaded related model.
   */
  async loadInvoice() { return await this.invoiceRelationship().load() }

  /**
   * Returns or loads invoice.
   * @returns {Promise<import("./invoice.js").Invoice | null>} - Loaded related model.
   */
  async invoiceOrLoad() { return await this.invoiceRelationship().orLoad() }

  /**
   * Sets invoice.
   * @param {import("./invoice.js").Invoice | null} model - Related model.
   * @returns {void}
   */
  setInvoice(model) { this.invoiceRelationship().setLoaded(model) }

  /**
   * Returns invoiceGroup relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<InvoiceGroupLink, import("./invoice-group.js").InvoiceGroup, import("./invoice-group.js").InvoiceGroupCreateAttributes>} - Relationship helper.
   */
  invoiceGroupRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<InvoiceGroupLink, import("./invoice-group.js").InvoiceGroup, import("./invoice-group.js").InvoiceGroupCreateAttributes>} */ (this.getRelationshipByName("invoiceGroup")) }

  /**
   * Returns invoiceGroup.
   * @returns {import("./invoice-group.js").InvoiceGroup | null} - Loaded related model.
   */
  invoiceGroup() { return this.invoiceGroupRelationship().loaded() }

  /**
   * Builds invoiceGroup.
   * @param {import("./invoice-group.js").InvoiceGroupCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./invoice-group.js").InvoiceGroup} - Built related model.
   */
  buildInvoiceGroup(attributes = {}) { return this.invoiceGroupRelationship().build(attributes) }

  /**
   * Loads invoiceGroup.
   * @returns {Promise<import("./invoice-group.js").InvoiceGroup | null>} - Loaded related model.
   */
  async loadInvoiceGroup() { return await this.invoiceGroupRelationship().load() }

  /**
   * Returns or loads invoiceGroup.
   * @returns {Promise<import("./invoice-group.js").InvoiceGroup | null>} - Loaded related model.
   */
  async invoiceGroupOrLoad() { return await this.invoiceGroupRelationship().orLoad() }

  /**
   * Sets invoiceGroup.
   * @param {import("./invoice-group.js").InvoiceGroup | null} model - Related model.
   * @returns {void}
   */
  setInvoiceGroup(model) { this.invoiceGroupRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(InvoiceGroupLink)

export {InvoiceGroupLink}

export default InvoiceGroupLink
